import { AbilityAction, AbilitySubject } from "@/enums/enums";
import { RevenueDeductPermissionModel } from "@/model/user/ApplicationPermissionModel";

export function DefineRevenueDeductPermissionAbility(revenueDeductPermission: RevenueDeductPermissionModel, can: any) {
  const { information, report } = revenueDeductPermission ?? {};

  information?.view && can(AbilityAction.Access, AbilitySubject.ViewRevenueDeduct);
  information?.create && can(AbilityAction.Create, AbilitySubject.CreateRevenueDeduct);
  information?.edit && can(AbilityAction.Update, AbilitySubject.EditRevenueDeduct);
  information?.delete && can(AbilityAction.Update, AbilitySubject.DeleteRevenueDeduct);

  report?.print && can(AbilityAction.Create, AbilitySubject.ExportRevenueDeduct);
}
